// @flow
import type { SpammyClickthroughWarning } from 'app/common/redux/reducers/ui/spammyClickthroughWarning';

export type SpammyClickthroughWarningShow = {|
  type: 'SPAMMY_CLICKTHROUGH_WARNING_SHOW',
  payload: SpammyClickthroughWarning,
|};

export type SpammyClickthroughWarningDismiss = { type: 'SPAMMY_CLICKTHROUGH_WARNING_DISMISS' };

export function showSpammyClickthroughWarning(spamCheck: SpammyClickthroughWarning) {
  return {
    type: 'SPAMMY_CLICKTHROUGH_WARNING_SHOW',
    payload: spamCheck,
  };
}

export function dismissSpammyClickthroughWarning() {
  return {
    type: 'SPAMMY_CLICKTHROUGH_WARNING_DISMISS',
  };
}
